define('views/pages/organization/index',['require','views/base/page','lib/utils','views/pages/organization/settings/index','views/pages/organization/users/index','views/pages/organization/markers/index','text!templates/pages/organization/index.ejs'],function(require) {
    'use strict';

    var PageView = require('views/base/page'),
        utils = require('lib/utils'),
        OrganizationSettingsView = require('views/pages/organization/settings/index'),
        OrganizationUsersView = require('views/pages/organization/users/index'),
        OrganizationMarkersView = require('views/pages/organization/markers/index'),
        template = require('text!templates/pages/organization/index.ejs');

    // ORGANIZATION

    var OrganizationPageView = PageView.extend({
        autoRender: true,
        template: template,
        id: 'pages-organization-page',
        regions: {
            'organization-settings-tab': '#organization-settings',
            'organization-users-tab': '#organization-users',
            'organization-markers-tab': '#organization-markers'
        },
        listen: {
            'change:page model': 'onChangePage',
            'change:haveMarkers model': 'render'
        },
        initialize: function() {
            PageView.prototype.initialize.apply(this, arguments);
            var self = this;

            this.model.settings.on('afterLoad', function(){
                self.model.set('haveMarkers', this.get('UseMarker') === 1);
            });

            this.delegate('click', '#organization-tabs>.nav-tabs a', this.onActivateTab);
        },
        onChangePage: function() {
            this.model[this.model.get('page')].trigger('activate');
            utils.changeURL('organization#show', {
                page: this.model.get('page')
            });
        },
        onActivateTab: function(ev) {
            console.log('onActivateTab');
            this.model.set('page', ev.target.href.split('-').pop());
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('settings', new OrganizationSettingsView({ model: this.model.settings }));
            this.subview('users', new OrganizationUsersView({ model: this.model.users }));
            this.subview('markers', new OrganizationMarkersView({ model: this.model.markers }));

            this.onChangePage();
        }
    });

    return OrganizationPageView;
});
